export const badges = [
  {
    id: 'first-responder',
    name: 'First Responder',
    icon: '🥇',
    description: 'Responded to 1st incident',
    requirement: 'Respond to your first emergency',
    points: 50
  },
  {
    id: 'speed-demon',
    name: 'Speed Demon',
    icon: '⚡',
    description: 'Avg response time < 3 mins',
    requirement: 'Maintain average response time under 3 minutes',
    points: 100
  },
  {
    id: 'guardian-angel',
    name: 'Guardian Angel',
    icon: '👼',
    description: 'Helped 5+ people',
    requirement: 'Successfully help 5 or more people',
    points: 150
  },
  {
    id: 'lifesaver',
    name: 'Lifesaver',
    icon: '❤️',
    description: '10+ medical responses',
    requirement: 'Respond to 10 medical emergencies',
    points: 200
  },
  {
    id: 'night-watch',
    name: 'Night Watch',
    icon: '🌙',
    description: 'Responded 10 PM-6 AM',
    requirement: 'Respond to emergencies during late night hours',
    points: 150
  },
  {
    id: 'community-hero',
    name: 'Community Hero',
    icon: '🏆',
    description: '20+ responses',
    requirement: 'Complete 20 successful responses',
    points: 250
  },
  {
    id: 'certified-helper',
    name: 'Certified Helper',
    icon: '📋',
    description: 'Uploaded first aid certificate',
    requirement: 'Upload verified first aid certification',
    points: 100
  },
  {
    id: 'streak-master',
    name: 'Streak Master',
    icon: '🔥',
    description: 'Responded 7 days in a row',
    requirement: 'Maintain a 7-day response streak',
    points: 200
  },
  {
    id: 'accuracy-expert',
    name: 'Accuracy Expert',
    icon: '🎯',
    description: 'Arrived within ETA 90% of time',
    requirement: 'Consistently arrive within estimated time',
    points: 150
  },
  {
    id: 'communicator',
    name: 'Communicator',
    icon: '💬',
    description: 'Sent 50+ chat messages',
    requirement: 'Actively communicate during emergencies',
    points: 100
  },
  {
    id: 'lightning-fast',
    name: 'Lightning Fast',
    icon: '🚀',
    description: 'Arrived in under 2 mins',
    requirement: 'Arrive at an emergency in under 2 minutes',
    points: 300
  },
  {
    id: 'trusted-guardian',
    name: 'Trusted Guardian',
    icon: '👥',
    description: 'In 5+ trusted circles',
    requirement: 'Be added to 5 people\'s trusted circles',
    points: 200
  },
  {
    id: 'area-protector',
    name: 'Area Protector',
    icon: '📍',
    description: '15+ responses in same area',
    requirement: 'Protect your local area consistently',
    points: 150
  },
  {
    id: 'five-star',
    name: 'Five Star Helper',
    icon: '⭐',
    description: '4.8+ average rating',
    requirement: 'Maintain excellent rating from victims',
    points: 250
  },
  {
    id: 'legend',
    name: 'Legend',
    icon: '🏅',
    description: 'Level 5 + 50+ responses',
    requirement: 'Become a true SafeCircle legend',
    points: 500
  }
];
